import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import PermitTable from "components/permit/PermitTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import PermitServices from "services/PermitServices";
import { FiPlus } from "react-icons/fi";
import PermitDrawer from "components/drawer/PermitDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { FiRefreshCcw } from "react-icons/fi";
import sidebar from "routes/sidebar";
import ExportDataXlsx from "components/common/ExportDataXlsx";

const Permit = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { data, loading, error } = useAsync(PermitServices.getAllPermit);
  const [permitData, setPermitData] = useState([]);
  const [status, setStatus] = useState(false);
  const { permitRef, dataTable, serviceData, handleSubmitPermit, currentPage } =
    useFilter(permitData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  useEffect(() => {
    if (data) {
      const responseData = data?.data || [];
      if (Array.isArray(responseData)) {
        const updatedData = responseData.map(
          ({
            id,
            vehicle_type_names,
            vehicle_type_id,
            permit,
            from_state,
            to_state,
            from_state_name,
            to_state_name,
            ...rest
          }) => ({
            id,
            vehicle_type_names,
            vehicle_type_id,
            permit,
            from_state,
            to_state,
            from_state_name,
            to_state_name,

            ...rest,
          }),
        );
        setPermitData(updatedData);
        setStatus(data?.status);
      } else {
        console.error("Expected an array but got:", responseData);
      }
    } else {
      console.error("Data is null or undefined");
    }
  }, [data]);

  const exportData = (data?.data || []).map((item, index) => {
    const vehicleNames = item.vehicle_type_names || {};
    const permit = item.permit || {};

    const vehicleColumns = Object.entries(vehicleNames).reduce(
      (acc, [vehicleId, vehicleName]) => {
        const permitValue = permit[vehicleId];

        acc[vehicleName] =
          permitValue !== undefined &&
          permitValue !== null &&
          permitValue !== ""
            ? permitValue
            : 0;

        return acc;
      },
      {},
    );

    return {
      "SI.No": index + 1,
      "ID": item.id || "",
      "Start State": item.from_state_name || "",
      "Start State ID": item.from_state || "",
      "End State": item.to_state_name || "",
      "End State ID": item.to_state || "",

      ...vehicleColumns,
    };
  });

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "permit" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "permit" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "permit" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "permit" && perm.add === 1,
      );

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <PermitDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={permitRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitPermit}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Permit
                  </Button>
                )}

                <div className="">
                  <ExportDataXlsx
                    title="Permit"
                    id_employee={adminInfo.id}
                    // exportDataXlsx={updatedData}
                    exportDataXlsx={exportData}
                    fileNames={`Permit List`}
                  />
                </div>

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer
                className="overflow-y-scroll"
                style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
              >
                <Table>
                  <TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
                    <TableRow>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Start State</TableCell>
                      <TableCell>End State</TableCell>
                      <TableCell>Vehicle Type</TableCell>
                      <TableCell>Permit</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHeader>
                  <PermitTable
                    permit={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    hideDelete={hideDelete}
                    hideEdit={hideEdit}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Permits." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Permit;
